import {
  AGENT_TYPE_HEADER,
  AGENT_VERSION_HEADER,
  ALLOW_ARBITRARY_QUERIES_HEADER,
  AUTHORIZATION_HEADER,
  AgentType,
  CSRF_SAFE_HEADER,
  CSRF_SAFE_HEADER_VALUE,
  ORG_ID_HEADER,
  OrgId,
  RETAIN_TRACE_HEADER,
  TRACE_ID_HEADER,
  createTraceId,
} from "@hex/common";

import { ORG_ID } from "../orgs";

import { getUserBearerToken } from "./bearerToken";
import { webClientVersion } from "./data";
import { getMcpBearerToken } from "./mcpOverrides";

export const createRequestHeaders = ({
  enableTracing,
  orgId,
}: {
  enableTracing?: boolean;
  orgId?: OrgId;
} = {}): Record<string, string> => {
  // TODO(nwold): If we're manually constructing this, it should probably be
  // its own type that we can share, to avoid accidentally thinking this is
  // a full-fledged Express headers object.
  const headers: Record<string, string> = {
    [CSRF_SAFE_HEADER]: CSRF_SAFE_HEADER_VALUE,
    [ORG_ID_HEADER]: orgId ?? ORG_ID,
    [TRACE_ID_HEADER]: createTraceId(),
    [AGENT_TYPE_HEADER]: AgentType.WEB_CLIENT,
    [AGENT_VERSION_HEADER]: webClientVersion ?? "<unknown>",
  };

  if (process.env.NODE_ENV !== "production") {
    headers[ALLOW_ARBITRARY_QUERIES_HEADER] = "true";
  }

  const bearerToken = getUserBearerToken() ?? getMcpBearerToken();
  if (bearerToken) {
    headers[AUTHORIZATION_HEADER] = `Bearer ${bearerToken}`;
  }

  if (enableTracing) {
    headers[RETAIN_TRACE_HEADER] = "true";
  }

  return headers;
};
